import React from 'react';
import ChoosenAddress from './ChoosenAddress';

export const getChoosenAddress = (condition, value, label, type) =>
  condition &&
  condition !== 'different' && <ChoosenAddress addressId={type} label={label} value={value} />;
